<template>
  <div>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="users"
      :loading="loading"
    >
      <template v-slot:item.action="{ item }">
        <v-btn
          small
          icon
          @click="$router.push(`/app/users-edit/${item.userId}`)"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  // props: {
  //   users: {
  //     type: Array,
  //   },

  //   loading: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  props: ["users", "loading"],

  data() {
    return {
      headers: [
        {
          text: "User Id",
          value: "userId",
        },
        {
          text: "Supplier Id",
          value: "supplierInternalId",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Created date",
          value: "createdDate",
        },
        {
          text: "Actions",
          value: "action",
        },
      ],
    };
  },
  methods: {},
};
</script>
